import { motion } from "framer-motion";
import { SmartImage } from "@/components/SmartImage";

export function PageHero({ title, eyebrow, subtitle, image }: {
  title: string; eyebrow?: string; subtitle?: string; image: string;
}) {
  return (
    <section className="relative h-[calc(60vh+30px)] min-h-[450px] max-h-[590px] flex items-end overflow-hidden">
      <SmartImage src={image} alt="" priority sizes="100vw" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/70" />
      <div className="container-x relative z-10 pb-16 text-primary-foreground">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          {eyebrow && <div className="text-gold uppercase tracking-[0.25em] text-xs mb-4">{eyebrow}</div>}
          <h1 className="font-display text-4xl md:text-6xl font-semibold max-w-3xl">{title}</h1>
          <div className="gold-line mt-6" />
          {subtitle && <p className="mt-5 max-w-2xl text-base md:text-lg opacity-90">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}
